import { useQuery } from '@tanstack/react-query-v4'
import { FeatureFlags } from '../types/FeatureFlags.ts'

/**
 * Loads the app feature flags.
 * Native fetch is used here to reduce the bundle size
 * because we use lazy loading for the app.
 */

interface MaintenanceSettings {
  flags: FeatureFlags
}

const loadAppMaintenanceSettings = async (): Promise<MaintenanceSettings> => {
  return {
    flags: {
      rewards: false,
      rewardsSummary: true,
    },
  }
}

export const useMaintenanceSettings = () =>
  useQuery({
    queryKey: ['maintenanceSettings'],
    queryFn: loadAppMaintenanceSettings,
    refetchOnWindowFocus: false,
    retry: false,
    refetchOnMount: false,
  })
